import type { Transaction } from "@rocicorp/zero";
import * as z from "zod";
import type { Schema } from "../generatedDrizzleSchema";

export const createOAuthConnectionSchema = z.object({
  provider: z.string(),
  clientId: z.string().optional(),
  scopes: z.array(z.string()).optional(),
});

type CreateOAuthConnection = z.infer<typeof createOAuthConnectionSchema>;

export async function insertFreshOAuthConnection(
  tx: Pick<Transaction<Schema>, "mutate">,
  spec: CreateOAuthConnection,
  id: string,
  tenantId: string
): Promise<void> {
  const now = Date.now();
  await tx.mutate.oauthConnections.insert({
    id,
    provider: spec.provider,
    scopes: spec.scopes ?? [],
    spaceIds: [],
    status: "not_connected",
    createdAt: now,
    updatedAt: now,
    tenantId,
  });
}
